/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var PLACEMENTS = Object.freeze({
  TOP_LEFT: 'top_left',
  TOP: 'top',
  TOP_RIGHT: 'top_right',
  RIGHT_TOP: 'right_top',
  RIGHT: 'right',
  RIGHT_BOTTOM: 'right_bottom',
  CENTER: 'center',
  BOTTOM_LEFT: 'bottom_left',
  BOTTOM: 'bottom',
  BOTTOM_RIGHT: 'bottom_right',
  LEFT_TOP: 'left_top',
  LEFT: 'left',
  LEFT_BOTTOM: 'left_bottom'
});

export { PLACEMENTS as P };
